<div class="mat-elevation-z8">
  <div class="toolbar">
    <div class="toolbar-left">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search by key or valueId" />
      </mat-form-field>
    </div>
    <div class="toolbar-right">
      <button mat-raised-button color="warn" (click)="clearAllCache()">
        <mat-icon>delete</mat-icon>
        Clear Full Cache
      </button>
    </div>
  </div>
  <div *ngIf="loading" class="loading-container">
    <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    <span class="loading-message">Loading...</span>
  </div>
  <div class="content-container" *ngIf="!loading">
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" matSort class="full-width-table">
        <ng-container matColumnDef="key">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Key</th>
          <td mat-cell *matCellDef="let row">{{ row.key }}</td>
        </ng-container>
        <ng-container matColumnDef="valueId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ValueId</th>
          <td mat-cell *matCellDef="let row">{{ row.valueId }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>View Details/Delete</th>
          <td mat-cell *matCellDef="let row">
            <button mat-icon-button (click)="viewKey(row.key)">
              <mat-icon>visibility</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="deleteKey(row.key)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="toggleSelection(row)"></tr>
      </table>
      <mat-paginator class="my-custom-paginator" [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
    </div>
    <div *ngIf="selectedKey" class="json-view">
      <div class="close-container">
        <button mat-icon-button color="primary" class="close-button" (click)="closeView()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <h3>Value for: {{ selectedKey }}</h3>

      <div *ngIf="viewLoading" class="loading-container">
        <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
        <span class="loading-message">Loading...</span>
      </div>

      <pre *ngIf="!viewLoading && selectedValue">{{ selectedValue | json }}</pre>
    </div>
  </div>
</div>

